/*
 * Smooth "You might also like" strip in the cart drawer.
 *
 * Why it glitched: every cart update re-renders [data-cart-items] and morphs it
 * into the drawer. The server HTML has the recommendations block empty + hidden,
 * so the morph wiped the products and hid the block, then the JS re-fetched and
 * re-inserted them (flash + layout jump).
 *
 * 1. Alpine.morph skips [data-cart-recommendations], so it keeps its content.
 * 2. fetchSectionHTML for the strip is wrapped so that:
 *    - an unchanged request (same product) doesn't replace the DOM again,
 *    - the first load shows skeleton cards,
 *    - a changed request dims the strip until the new products arrive.
 *    New products fade in via CSS (magnefico-custom.css).
 * 3. The right edge of the strip fades out while there is more to scroll to
 *    (class has-fade-end on the block, styled in magnefico-custom.css).
 */
;(function () {
  var SELECTOR = '.cart-recommendations__slider-items'
  var loadedUrl = typeof WeakMap === 'function' ? new WeakMap() : null

  function skeletonHTML() {
    var card =
      '<div class="cart-recommendations__item cart-recommendations__item--skeleton" aria-hidden="true">' +
      '<div class="cart-recommendations__skeleton-image"></div>' +
      '<div class="cart-recommendations__skeleton-line"></div>' +
      '<div class="cart-recommendations__skeleton-line cart-recommendations__skeleton-line--short"></div>' +
      '</div>'
    return card + card + card + card
  }

  var observed = typeof WeakSet === 'function' ? new WeakSet() : null

  function updateFade(container) {
    var slider = container.querySelector('.cart-recommendations__slider')
    if (!slider) return
    var canScroll = slider.scrollWidth - slider.clientWidth > 1
    var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1
    container.classList.toggle('has-fade-end', canScroll && !atEnd)
  }

  // re-check whenever products are inserted / removed
  function watch(container) {
    var slider = container.querySelector('.cart-recommendations__slider')
    if (!slider || !observed || observed.has(slider)) return
    observed.add(slider)
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        requestAnimationFrame(function () {
          updateFade(container)
        })
      }).observe(slider, { childList: true })
    }
    updateFade(container)
  }

  // scroll events don't bubble, so listen in the capture phase
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target
      if (t && t.classList && t.classList.contains('cart-recommendations__slider')) {
        var container = t.closest('[data-cart-recommendations]')
        if (container) updateFade(container)
      }
    },
    true
  )
  window.addEventListener('resize', function () {
    var list = document.querySelectorAll('[data-cart-recommendations]')
    for (var i = 0; i < list.length; i++) updateFade(list[i])
  })

  function findContainer(url) {
    var list = document.querySelectorAll('[data-cart-recommendations]')
    for (var i = 0; i < list.length; i++) {
      var base = list[i].dataset.url
      if (base && url.indexOf(base) === 0) return list[i]
    }
    return null
  }

  function patchMorph() {
    if (
      !window.Alpine ||
      typeof window.Alpine.morph !== 'function' ||
      window.Alpine.morph.__keepsRecommendations
    )
      return

    var originalMorph = window.Alpine.morph
    var wrapped = function (el, html, options) {
      options = options || {}
      var userUpdating = options.updating

      return originalMorph(
        el,
        html,
        Object.assign({}, options, {
          updating: function (from, to, childrenOnly, skip) {
            if (
              from &&
              from.nodeType === 1 &&
              from.hasAttribute('data-cart-recommendations')
            ) {
              // keep the block, but follow the cart's first product so the
              // recommendations still refresh when that product changes
              var productId = to && to.getAttribute('data-product-id')
              if (productId) from.setAttribute('data-product-id', productId)
              return skip()
            }
            if (userUpdating) return userUpdating(from, to, childrenOnly, skip)
          },
        })
      )
    }
    wrapped.__keepsRecommendations = true
    window.Alpine.morph = wrapped
  }

  function patchFetch() {
    var original = window.fetchSectionHTML
    if (typeof original !== 'function' || original.__smoothRecommendations)
      return

    var wrapped = function (url, selector) {
      var container =
        selector === SELECTOR && typeof url === 'string'
          ? findContainer(url)
          : null
      if (!container) return original.apply(this, arguments)

      var slider = container.querySelector('.cart-recommendations__slider')
      if (!slider) return original.apply(this, arguments)
      watch(container)

      var hasProducts = !!slider.querySelector(
        '.cart-recommendations__item:not(.cart-recommendations__item--skeleton)'
      )

      // same products already showing -- leave the DOM alone
      if (hasProducts && loadedUrl && loadedUrl.get(container) === url) {
        return Promise.resolve(null)
      }

      if (hasProducts) {
        container.classList.add('is-refreshing')
      } else {
        slider.innerHTML = skeletonHTML()
        container.hidden = false
      }

      function settle(html) {
        container.classList.remove('is-refreshing')
        if (html === null) {
          // request failed / no section: keep products already on screen,
          // otherwise drop the skeleton and hide the block
          if (!hasProducts) {
            slider.innerHTML = ''
            container.hidden = true
          }
        } else if (!String(html).trim()) {
          // the caller empties the slider and hides the block itself
        } else if (loadedUrl) {
          loadedUrl.set(container, url)
        }
        return html
      }

      return original.apply(this, arguments).then(settle, function (err) {
        settle(null)
        throw err
      })
    }
    wrapped.__smoothRecommendations = true
    window.fetchSectionHTML = wrapped
  }

  patchFetch()
  patchMorph()
  document.addEventListener('alpine:init', patchMorph)
  document.addEventListener('DOMContentLoaded', function () {
    patchFetch()
    patchMorph()
  })
})()
